export default __webpack_public_path__ + "static/media/bg-image-1.6763cff0.jpg";